/** Classic WORD_SEARCH / HIDDEN_MESSAGE board edge. */
export const DEFAULT_GRID_SIZE = 12;

/**
 * Resolve board rows×cols from a grid template.
 * HIDDEN_MESSAGE is always 12×12. Prefer gridRows/gridCols.
 */
export function resolveTplGridDims(gridTpl) {
    if (!gridTpl || gridTpl.type === "HIDDEN_MESSAGE") {
        return { rows: DEFAULT_GRID_SIZE, cols: DEFAULT_GRID_SIZE };
    }
    const rows = Number(gridTpl.gridRows ?? gridTpl.grid_rows);
    const cols = Number(gridTpl.gridCols ?? gridTpl.grid_cols);
    if (Number.isFinite(rows) && rows > 0 && Number.isFinite(cols) && cols > 0) {
        return { rows, cols };
    }
    return { rows: DEFAULT_GRID_SIZE, cols: DEFAULT_GRID_SIZE };
}

/**
 * Longer edge (max word length / square UI that still assumes one size).
 * Prefer {@link resolveTplGridDims} for rectangular boards.
 */
export function resolveTplGridSize(gridTpl) {
    const { rows, cols } = resolveTplGridDims(gridTpl);
    return Math.max(rows, cols);
}

/** @deprecated use resolveTplGridDims / resolveTplGridSize */
export function normalizeGridSize(value) {
    const n = Number(value);
    return n === 9 || n === 12 ? n : DEFAULT_GRID_SIZE;
}
